import { useEffect } from 'react';
import { configApiRef, fetchApiRef, useApi, useApiHolder } from '@backstage/core-plugin-api';
import { signOutHooksApiRef } from '@platform/plugin-platform-react';

/**
 * Élément racine : enregistre auprès du socle la fermeture de la session
 * Keycloak, exécutée avant la déconnexion. Le backend retrouve l'utilisateur
 * par son cookie : il faut donc que l'appel parte avant `identityApi.signOut()`.
 *
 * L'API des crochets est lue de façon optionnelle : un élément racine qui
 * lève finit dans l'errorApi, et la déconnexion n'a pas à en dépendre.
 */
export const KeycloakSessionSignOut = () => {
  const configApi = useApi(configApiRef);
  // fetchApi : ajoute le jeton Backstage. `credentials: 'include'` reste
  // explicite : en dev le front (3001) et le backend (7007) sont cross-origin,
  // et sans lui le cookie Keycloak ne part pas.
  const fetchApi = useApi(fetchApiRef);
  const hooks = useApiHolder().get(signOutHooksApiRef);
  const backendUrl = configApi.getString('backend.baseUrl');

  useEffect(() => {
    if (!hooks) return undefined;
    return hooks.register(async () => {
      await fetchApi.fetch(`${backendUrl}/api/keycloak-admin/logout`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
      });
    });
  }, [hooks, fetchApi, backendUrl]);

  return null;
};
